module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_v",
      "title": "v"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To my dear mother, Barbara, for your unceasing faith and confidence in me. And to my wife, Alisha, for your extreme patience and love and immeasurable support. We made it. At long last, we’re here.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—B.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To Kimberly, who has my hand and my heart")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—L.S.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0